var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShouldersBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19342 11.3325C7.96402 13.1238 8.37623 15.0486 8.40675 16.9984C8.40675 19.6417 7.09592 21.3967 6.35925 23.9209",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8066 11.3325C18.036 13.1238 17.6238 15.0486 17.5933 16.9984C17.5933 19.6417 18.9041 21.3967 19.6408 23.9209",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6923 2.0249C10.6895 2.75427 10.4696 3.46629 10.0605 4.07018C9.65151 4.67407 9.07193 5.14249 8.39567 5.41574L5.08067 6.75907C4.65489 6.92647 4.28482 7.21031 4.01278 7.57814C3.74074 7.94597 3.57771 8.38294 3.54233 8.83907C3.38029 9.9191 3.40963 11.0192 3.629 12.0891L4.33317 15.7941",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3074 2.0249C15.3102 2.75427 15.5301 3.46629 15.9392 4.07018C16.3482 4.67407 16.9278 5.14249 17.604 5.41574L20.919 6.75907C21.3448 6.92647 21.7149 7.21031 21.9869 7.57814C22.259 7.94597 22.422 8.38294 22.4574 8.83907C22.6194 9.9191 22.5901 11.0192 22.3707 12.0891L21.6665 15.7941",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5562V21.1028",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShouldersBack);
export default __webpack_public_path__ + "static/media/shoulders-back.c2e30e5e49365fda34bd04760bd5e137.svg";
export { ForwardRef as ReactComponent };